import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { APDEditBulkUpload } from "@/features/apd/APDEditBulkUpload";

export function APDEditBulk() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/apd",
            label: "APD",
          },
          {
            label: "Edit Bulk APD",
          },
        ]}
      />
      <H2>Edit Bulk APD</H2>
      <APDEditBulkUpload />
    </>
  );
}
